import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        patrimonies: 'patrimoines',
        patrimony: 'patrimoine',
        newPatrimony: 'nouveau patrimoine',
        updatePatrimony: 'modification',
        searchPatrimony: {
            xs: 'patrimoine',
            sm: 'rechercher votre patrimoine'
        },
        searchStream: {
            xs: 'rechercher',
            sm: 'rechercher un patrimoine'
        },
        searchAgency: {
            xs: 'portefeuille',
            sm: 'rechercher votre portefeuille'
        },
        useSearchPatrimonyFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
        useSearchContactFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
        newLot: 'nouveau lot',
        updateLot: 'modification',
        deleteLot: 'supprimer le lot ...',
        deleteLotText: [
            'Vous êtes sur le point de supprimer le lot {ref}.',
            'Cette action est irréversible.'
        ],
        lot: 'lot',
        lots: 'lots',
        lotNumber: 'numéro de lot',
        usage: 'sous catégorie',
        usageEnum: {
            residentialParking: 'parking',
            residentialCellar: 'cave',
            residentialAnnex: 'annexe',
            apartment: 'appartement',
            individualHouse: 'maison individuelle',
            tertiaryParking: 'parking',
            workspace: 'surface',
            workstation: 'poste de travail',
            office: 'bureau',
            retailShop: 'commerce / boutique',
            warehouse: 'entrepôt',
            gasStation: 'station service',
            meetingRoom: 'salle de réunion',
            restaurant: 'restaurant',
            fitness: 'fitness',
            spa: 'spa',
            sportFacility: 'équipement sportif',
            pool: 'piscine',
            poolHouse: 'pool house',
            playground: 'jeux d\'enfants',
            laundry: 'laverie',
            otherService: 'autre',            
            boilerRoom: 'chaufferie',
            elevator: 'ascenseur',
            ventilationSystem: 'ventilation',
            gate: 'porte / portail',
            intercom: 'interphone',
            binStorageArea: 'local poubelle',
            machineRoom: 'local technique',
            gardeningShed: ' local jardin',
            otherTechnical: 'autre'
        },
        usageGroupEnum: {
            residential: 'résidentiel',
            tertiary: 'tertiaire',
            service: 'service',
            technical: 'technique'
        },
        patrimonyContact: 'contact',
        patrimonyContacts: 'contacts',
        patrimonyContactsFilteredByPatrimony: 'contacts du patrimoine',
        allPatrimonyContacts: 'tous les contacts',
        newPatrimonyContact: 'nouveau contact',
        updatePatrimonyContact: 'modification',
        linkPatrimonyContact: 'associer un contact',
        unlinkPatrimonyContact: 'dissocier un contact',
        patrimonyContactLinkType: 'role',
        patrimonyContactLinkTypeEnum: {
            linkToPatrimonyAsHomeOwnerAssociation: {
                default: 'conseil syndical',
                member: 'membre du conseil syndical',
                president: 'président du conseil syndical'
            },
            linkToPatrimonyAsCareTaker: 'gardien',
            linkToLotAsTenant: 'locataire',
            linkToLotAsOwner: 'propriétaire',
            linkToLotAsLandlord: 'propriétaire bailleur',
            linkToNonReferencedLot: {
                default: 'lot non réfeŕencé',
                tenant: 'locataire',
                owner: 'propriétaire',
                landlord: 'propriétaire bailleur'
            }
        },
        patrimonyUserLinkTypeEnum: {
            CallCenterUser: 'utilisateur',
            CallCenterOperator: 'opérateur',
            ClientAccountManager: 'administrateur',
            Executive: 'cadre',
            PatrimonyManager: 'gestionnaire'
        },

        homeOwnerAssociation: 'conseil syndical',
        homeOwnerAssociationPosition: 'position',
        linkedToNonReferencedLotPosition: 'titi',
        homeOwnerAssociationPositionEnum: {
            member: 'membre du conseil syndical',
            president: 'président du conseil syndical'
        },
        complementaryAddresses: 'adresses complémentaires',
        addAddress: 'ajouter une adresse',
        removeAddress: 'supprimer l\'adresse',
        synthesis: 'synthèse',
        additionalInfos: 'Informations',
        directory: 'annuaire',
        tickets: 'tickets',
        audits: 'audits',
        newAudit: 'audit',
        lastAudits: 'derniers audits',
        providers: 'fournisseurs',
        documents: 'documents',
        agency: 'portefeuille',
        agencies: 'portefeuilles',
        addAgency: 'ajouter un portefeuille',
        building: 'bâtiment',
        buildings: 'bâtiments',
        currentYearStats: 'statistiques sur l\'année en cours',
        openedTickets: 'tickets ouverts',
        nextInterventions: 'interventions à venir',
        newAudits: 'audits réalisés',
        nextPatrimonyEvent: 'prochain évènement du patrimoine',
        nextLotEvent: 'prochain évènement du lot',
        nextBuildingEvent: 'prochain évènement du bâtiment',
        description: 'description',
        callPurpose: 'type d\'incident',
        providersTop10: 'top 10 des fournisseurs',
        powerConsumption: 'conso. élect.',
        elevator: 'ascenseur',
        addressCount: 'nombre d\'adresses',
        referenceInfo: 'identifiant spécifique à la gestion du lot',
        lotNumberInfo: 'identifiant administratif du lot dans son patrimoine',
        nameType: 'type de contact',
        nameTypeEnum: {
            civilName: 'individu',
            poorName: 'service'
        },
        gender: 'civilité',
        genderEnum: {
            male: 'M.',
            female: 'Mme.'
        },
        contactDetails: 'informations de contact',
        contactDetailsText: 'Merci de renseigner au moins un moyen de contact',
        reportPdfPatrimony: 'Télécharger le rapport PDF',
        reportingPatrimony: 'Téléchargement en cours',
        patrimonyUser : {
            createInSameTime: 'Inviter le contact à se connecter',
            linkToUserError: 'Un utilisateur existe déjà avec cet email',
            linkToUser: 'Associer',
            stateToIcon: {
                NoAccount:'',
                ActiveAccount:'opened',
                NotActiveAccount:'closed',
            },
            stateToTooltip: {
                NoAccount:'Pas de compte utilisateur',
                ActiveAccount:'Compte utilisateur actif',
                NotActiveAccount:'Compte utilisateur inactif',
            },
            title: {
                NoAccount:'Inviter le contact à se connecter',
                ActiveAccount:'Désactiver le compte utilisateur',
                NotActiveAccount:'Modifier le compte utilisateur',
            },
        },
        userAccount: 'Compte utilisateur',
        user : {
            login: 'email',
            disable : 'désactiver l\'utilisateur ...',
            sendActivationEmail: 'renvoyer l\'email d\'activation',
            activationEmailSent: 'un email a été envoyé',
        }
    }
}

export default {
    ...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/patrimony/i18n.js